module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('a', {
    staticClass: "footer-link",
    attrs: {
      "href": "http://www.raisetech.com.np"
    }
  }, [_vm._v("eCalculo ERP.")]), _vm._v(" "), _c('p', {
    staticClass: "footer-copy"
  }, [_vm._v("\n      Copyright © " + _vm._s(_vm.year) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "footer-right"
  }, [_vm._v("\n      All rights reserved\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8eaaee5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DashFooter.vue
// module id = 2361
// module chunks = 0